import styled from 'styled-components'
import {Link} from 'react-router-dom'


export const Wrapper = styled.div`
font-size: 40px;
display: flex;
justify-content: center;
padding: 10px;
text-align: center;
`

export const Button = styled(Link)`
display: flex;
align-items: center;
justify-content: center;
width: 12vw;
height: 6vh;
margin: 100px auto 0;
border: 2px solid #FF4C00;
color: #fff;
background-color: inherit;
font-family: ${({font}) => (font==='') ? 'inherit' : font};
font-size: 24px;
text-align: center;
text-decoration: none;
cursor: pointer;
opacity: 0.9;
align-self: ${({img_first}) => img_first ? 'inherit' : 'flex-end'};

@media screen and (max-width: 768px) {
    margin: 0 auto;
    width: 30vw;
    height: 4vh;
    font-size: 15px;
    line-height: 3vh;
    padding: 0.27vh 0;
}

@media screen and (max-width: 480px) {
    font-size: 10px;
}

&:hover, &:active {
    text-decoration: none;
    color: white;
}

&:hover{
    text-decoration: none;

    background-color: #FF4C00;
    opacity: 1;
}

&:active{
    background-color: #FF4C00;
    opacity: 1.2;
}

`
